<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="700px"
    >
      <v-card
        shaped
        color="#ECEFF1"
      >
        <br>
        <div class="d-flex  justify-space between">
          <h2 class="modal-title-style">
            <v-icon class="modal-icon-style">
              mdi-phone
            </v-icon> Contact Us
          </h2>

          <v-icon
            style="margin-left: 450px;"
            @click="showModal = false"
          >
            mdi-close-thick
          </v-icon>
        </div>
        <v-card-text>
          <v-form>
            <v-container fluid>
              <div class="div-style">
                <p
                  class="my-p-style"
                >
                  <font>
                    {{ contactMessage }}
                  </font>
                </p>
                <p
                  class="contact-style"
                >
                  <font>
                    <v-icon color="#37474F">
                      mdi-email
                    </v-icon>
                    info@dbsystems.com.au
                  </font>
                </p>
                <p
                  class="contact-style"
                >
                  <font>
                    <v-icon color="#37474F">
                      mdi-phone
                    </v-icon>
                    0401 750 181 (Melbourne)
                  </font>
                </p>
                <p
                  class="contact-style"
                >
                  <font>
                    <v-icon color="#37474F">
                      mdi-phone
                    </v-icon>
                    0400 482 818 (Sydney)
                  </font>
                </p>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <br>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  name: 'ContactForPurchase',
  props: {
    contactMessage: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showModal: true,
    };
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
};
</script>
<style scoped>
.my-p-style {
  font-size: 20px;
  font-weight: bold;
  color: #ff3700;
  font-family:'Times New Roman', Times, serif;
}
.modal-title-style {
  color: #37474F;
  margin-left: 30px;
}
.modal-icon-style {
  color: #37474F;
  font-size: 45px;
}
.div-style {
    text-align: center;
}
.contact-style {
    font-size: 18px;
    color: #37474F;
    font-weight: bold;
    font-family: 'Times New Roman', Times, serif;
}
</style>
